<!-- You can change the color from black to white if you like by using the textWhite boolean -->

<template>
  <NuxtLink v-if="!mobileMenusStore.mobileFilterStatus && !mobileMenusStore.overviewHeaderActive" :to="url" :title="title" :class="{ 'lyre-position-to-header': !flush }">
    <AtomBrandConcertgebouwLyre class="w-6 h-10" :class="{ 'text-white': whiteLyre, 'text-black': !whiteLyre }" />
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps({
  url: { type: String, required: false, default: '/' },
  title: { type: String, required: false, default: 'Home' },
  whiteLyre: { type: Boolean, required: false, default: false },
  flush: { type: Boolean, required: false, default: false },
})

const mobileMenusStore = useMobileMenusStore()
</script>

<style lang="scss">
// scoped scss is not suitable for this component, it won't work in this case because it needs to inherit styles from parent elements

// This style is set default, to make it appear at the right spot because it is always sitting right underneath the site header,
// but you CAN disable it by setting the flush option to true if you want to use this button on another spot than the header.
.lyre-position-to-header {
  @apply absolute z-10 bottom-0 right-0 -mb-12 mr-4; //-mb-12 is optimized for the event detail template
  /* Keep icon tappable, but don't block the overview search bar beside it */
  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  @screen lg {
    @apply mr-8;
  }

  @screen xl {
    @apply hidden;
  }
}
</style>
